/* PricingDisplaySection.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"],
  _excluded7 = ["as", "style"],
  _excluded8 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _19 = "._otyroahv{margin-bottom:var(--ds-space-600,3pc)}";
const _18 = "._syazalr3{color:#172b4d}";
const _17 = "._18u01b66{margin-left:var(--ds-space-050,4px)}";
const _16 = "._19pk1b66{margin-top:var(--ds-space-050,4px)}";
const _15 = "._1tke146b{min-height:110px}";
const _14 = "._otyr87mh{margin-bottom:var(--ds-space-250,22px)}";
const _13 = "._19pku2gc{margin-top:var(--ds-space-100,8px)}";
const _12 = "._1wybdlk8{font-size:14px}";
const _11 = "._otyridpf{margin-bottom:0}";
const _10 = "._1wyb7vkz{font-size:1pc}";
const _9 = "._1e0c1txw{display:flex}";
const _8 = "._19pkpxbi{margin-top:var(--ds-space-200,1pc)}";
const _7 = "._1wyb1tcg{font-size:24px}";
const _6 = "._k48pni7l{font-weight:600}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Button from '@atlaskit/button';
import EditorPanelIcon from '@atlaskit/icon/glyph/editor/panel';
import { media } from '@atlaskit/primitives/responsive';
import { N800 } from '@atlaskit/theme/colors';
import Tooltip from '@atlaskit/tooltip';
import { H5 } from '@atlassian/mpac-primitives';
import { MarketplaceBillingCycle as BillingCycle } from '@atlassian/mpac-types/graphql-gateway-types';
import React from 'react';
import { FREE_APP_CTA_LABEL_PRIMARY, PAID_APP_CTA_LABEL_START_TRIAL, PER_USER_PRICING_FORMAT_MIN_FRACTION_DIGITS, TEST_ID } from '../../../../../../../../constants';
import { formatAmount } from '../../../PricingTab.utils';
import { getTierCeiling } from '../CloudPricingCalculator.utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _5 = "@media not all and (min-width:90rem){._1eog1ejb{padding-top:var(--ds-space-300,24px)}}";
const _4 = "._1bsbuuw1{width:200px}";
const _3 = "._1wpz1h6o{align-self:center}";
const _2 = "._y3gn1h6o{text-align:center}";
const _ = "._1bah1h6o{justify-content:center}";
const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1bah1h6o _y3gn1h6o _1wpz1h6o _1bsbuuw1 _1eog1ejb", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
export const AppCost = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _7, _8]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_k48pni7l _1wyb1tcg _19pkpxbi", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppCost.displayName = 'AppCost';
}
export const AppCostHeading = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = H5,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _, _10, _11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _1bah1h6o _1wyb7vkz _otyridpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppCostHeading.displayName = 'AppCostHeading';
}
export const AppCostDescription = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_12, _13, _14]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1wybdlk8 _19pku2gc _otyr87mh", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppCostDescription.displayName = 'AppCostDescription';
}
const AppCostContent = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_15]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1tke146b", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppCostContent.displayName = 'AppCostContent';
}
export const AppCostDuration = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_12, _16]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1wybdlk8 _19pk1b66", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppCostDuration.displayName = 'AppCostDuration';
}
export const AppCostQuestionIcon = forwardRef((_ref7, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref7,
    __cmplp = _objectWithoutProperties(_ref7, _excluded7);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_17]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18u01b66", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppCostQuestionIcon.displayName = 'AppCostQuestionIcon';
}
export const MaxUserCountExceeded = forwardRef((_ref8, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref8,
    __cmplp = _objectWithoutProperties(_ref8, _excluded8);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _12, _18, _8, _19]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_y3gn1h6o _1wybdlk8 _syazalr3 _19pkpxbi _otyroahv", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  MaxUserCountExceeded.displayName = 'MaxUserCountExceeded';
}
export const getDuration = billingCycle => {
  if (billingCycle === BillingCycle.Monthly) return 'per month';
  return 'per year';
};
const appCostDescription = (userCount, appAmount, currency, billingCycle, annualPricingTier) => {
  const annualPricingTierCeiling = getTierCeiling(annualPricingTier);
  if (appAmount === 0) {
    return "up to ".concat(annualPricingTierCeiling, " users");
  }
  if (billingCycle === BillingCycle.Monthly) {
    const formatedAmount = formatAmount(userCount ? appAmount / userCount : 0, {
      currency,
      minimumFractionDigits: PER_USER_PRICING_FORMAT_MIN_FRACTION_DIGITS
    });
    return "".concat(formatedAmount, " per user (average)");
  }
  return "User tier: ".concat(annualPricingTier.floor, "-").concat(annualPricingTierCeiling);
};
const PricingDisplaySection = _ref9 => {
  let {
    userCount,
    appAmount,
    currency,
    billingCycle,
    annualPricingTier,
    onPricingCalculatorInstallCTAClick,
    lastTierCeiling
  } = _ref9;
  const CTAlabel = appAmount === 0 ? FREE_APP_CTA_LABEL_PRIMARY : PAID_APP_CTA_LABEL_START_TRIAL;
  const handleCTAClick = () => {
    onPricingCalculatorInstallCTAClick({
      billingCycle,
      userCount,
      label: CTAlabel
    });
  };
  const costDescription = appCostDescription(userCount, appAmount, currency, billingCycle, annualPricingTier);
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsxs("div", {
      "aria-live": "polite",
      role: "status",
      "aria-relevant": "all",
      children: [/*#__PURE__*/_jsxs(AppCostHeading, {
        as: "h3",
        children: ["App cost", /*#__PURE__*/_jsx(Tooltip, {
          content: "Price shown excludes tax and is calculated progressively using user tier prices",
          position: "right",
          children: /*#__PURE__*/_jsx(AppCostQuestionIcon, {
            children: /*#__PURE__*/_jsx(EditorPanelIcon, {
              size: "small",
              label: ""
            })
          })
        })]
      }), userCount > lastTierCeiling ? /*#__PURE__*/_jsxs(MaxUserCountExceeded, {
        children: ["The maximum number of users supported is ", lastTierCeiling, ". Try a different user count."]
      }) : /*#__PURE__*/_jsxs(AppCostContent, {
        children: [/*#__PURE__*/_jsx(AppCost, {
          children: appAmount === 0 ? 'Free' : "".concat(formatAmount(appAmount, {
            currency,
            minimumFractionDigits: PER_USER_PRICING_FORMAT_MIN_FRACTION_DIGITS
          }))
        }), appAmount !== 0 && /*#__PURE__*/_jsx(AppCostDuration, {
          children: getDuration(billingCycle)
        }), /*#__PURE__*/_jsx(AppCostDescription, {
          children: costDescription
        })]
      })]
    }), /*#__PURE__*/_jsx(Button, {
      appearance: "primary",
      isDisabled: userCount > lastTierCeiling,
      onClick: handleCTAClick,
      testId: TEST_ID.PRICING_TAB_INSTALL_CTA,
      children: CTAlabel
    })]
  });
};
export default PricingDisplaySection;